import React, { createContext, useReducer, useContext } from "react";
import { LiferayService } from "../../../common/services/liferay/index";
import { ApplicationPropertiesContext } from "../../../common/context/ApplicationPropertiesProvider";
import { getSignedIdStatus, decode_utf8, getPathName } from "../../../common/utils/utilsFunc";

export const EnergyReconversionContext = createContext();

export const ACTIONS = {
  SET_WEB_CONTENT_TERMINOS_Y_CONDICIONES: "SET_WEB_CONTENT_TERMINOS_Y_CONDICIONES",
  SET_ERROR:"SET_ERROR",
  SET_IDCLIENT:"SET_IDCLIENT",
  SET_IDCLIENT_AUX:"SET_IDCLIENT_AUX",
  SET_DETAIL_CLIENT:"SET_DETAIL_CLIENT",
  SET_OPTIONS_MECHANISMS_RESPONSE:"SET_OPTIONS_MECHANISMS_RESPONSE",
  SET_FORM_DATA:"SET_FORM_DATA",
  SET_RESPONSE_FORM:"SET_RESPONSE_FORM",
  SET_WEB_CONTENT_TEXT_INFO: "SET_WEB_CONTENT_TEXT_INFO",

};

const initialState = {
    webContentTerminosCondiciones:null,
    idClient: null,
    detailClient: null,
    errorFetch: null,
    formData:null,
    responseFormData:null,
    webContentTextInfo: "",
    idClientAux: null,


};
const EnergyReconversionReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.SET_OPTIONS_MECHANISMS_RESPONSE: {
      return {
          ...state,
          optionsMechanismsResponse: action.payload,
      };
    }
    case ACTIONS.SET_WEB_CONTENT_TERMINOS_Y_CONDICIONES: {
      return {
          ...state,
          webContentTerminosCondiciones: action.payload,
      };
    }
    case ACTIONS.SET_IDCLIENT: {
      return {
          ...state,
          idClient: action.payload
      };
    }
    case ACTIONS.SET_IDCLIENT_AUX: {
      return {
          ...state,
          idClientAux: action.payload
      };
    }
    case ACTIONS.SET_DETAIL_CLIENT: {
      return {
          ...state,
          detailClient: action.payload
      };
    }
    case ACTIONS.SET_FORM_DATA: {
      return {
          ...state,
          formData: action.payload
      };
    }
    case ACTIONS.SET_RESPONSE_FORM: {
      return {
          ...state,
          responseFormData: action.payload
      };
    }
    case ACTIONS.SET_ERROR: {
      return {
          ...state,
          errorFetch: action.payload
      };
    }
    case ACTIONS.SET_WEB_CONTENT_TEXT_INFO: {
      return {
        ...state,
        webContentTextInfo: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
const EnergyReconversionContextProvider = ({ children }) => {
  const properties = useContext(ApplicationPropertiesContext);

  const [state, dispatch] = useReducer(EnergyReconversionReducer, initialState);

  React.useEffect(() => {
    if (state.formData && getPathName() === 'solicitud-reconversion-energetica') {
      LiferayService.setFormRe(properties.base_url_api,state.formData,properties.url_ws_empresa, properties.codigo_empresa,getSignedIdStatus())
      .then((response) => {
        dispatch({
            payload: response,
            type: ACTIONS.SET_RESPONSE_FORM,
        });
        dispatch({
            payload: null,
            type: ACTIONS.SET_FORM_DATA,
        });
      })
    }
  }, [state.formData]);

  React.useEffect(() => {
    if (getPathName() === 'solicitud-reconversion-energetica') {
        if(properties.web_content_terminos_y_condiciones){
            LiferayService.getWebContent(properties.base_url_api,decode_utf8(properties.web_content_terminos_y_condiciones).trim())
            .then((response) => {
                dispatch({
                    payload: response,
                    type: ACTIONS.SET_WEB_CONTENT_TERMINOS_Y_CONDICIONES,
                });
            })
        }
        LiferayService.getMechanisms(properties.base_url_api)
        .then((response) => {
            dispatch({
                payload: response,
                type: ACTIONS.SET_OPTIONS_MECHANISMS_RESPONSE,
            });
        });
        if (decode_utf8(properties.web_content_info_update_of_contact_information).trim()) {
          LiferayService.getWebContent(properties.base_url_api, decode_utf8(properties.web_content_info_update_of_contact_information).trim())
          .then((response) => {
            dispatch({
              payload: response,
              type: ACTIONS.SET_WEB_CONTENT_TEXT_INFO,
            });
          })
        }
    }
  }, []);

  React.useEffect(() => {
    if(state.idClient){
        dispatch({
          payload: state.idClient,
          type: ACTIONS.SET_IDCLIENT_AUX,
        }); 
        LiferayService.consultarDetalleInstalacionPorCuentaContrato(properties.base_url_api,state.idClient, properties.url_ws_empresa, properties.codigo_empresa)
        .then((response) =>{
            dispatch({
                payload: response,
                type: ACTIONS.SET_DETAIL_CLIENT,
            });
            dispatch({
                payload: null,
                type: ACTIONS.SET_ERROR,
            });
            dispatch({
                payload: null,
                type: ACTIONS.SET_IDCLIENT,
            });
            })
        .catch((error) => {
            dispatch({
            payload: error,
            type: ACTIONS.SET_ERROR,
            });
        })
      }
  },[state.idClient])
  
  
  return (
    <EnergyReconversionContext.Provider value={[state, dispatch]}>
      {children}
    </EnergyReconversionContext.Provider>
  );
};
export default EnergyReconversionContextProvider;